import { mapState, mapGetters, mapActions } from 'vuex'
import Vue from 'vue';
import config from "../../src/config/config";
import moment from 'moment';

export const authComputed = {
  ...mapState('auth', {
    currentUser: (state) => state.currentUser,
  }),
  ...mapGetters('auth', ['loggedIn']),
}

export const layoutComputed = {
  ...mapState('layout', {
    layoutType: (state) => state.layoutType,
    leftSidebarType: (state) => state.leftSidebarType,
    layoutWidth: (state) => state.layoutWidth,
    topbar: (state) => state.topbar,
    loader: (state) => state.loader
  })
}

const authMethods = mapActions('auth', ['logIn', 'logOut', 'register', 'resetPassword'])

const layoutMethods = mapActions('layout', ['changeLayoutType', 'changeLayoutWidth', 'changeLeftSidebarType', 'changeTopbar', 'changeLoaderValue'])

const authFackMethods = mapActions('authfack', ['login', 'registeruser', 'logout'])

const notificationMethods = mapActions('notification', ['success', 'error', 'clear'])

const debounce = (func, delay) => { 
  let debounceTimer 
  return function() { 
      const context = this
      const args = arguments 
        clearTimeout(debounceTimer) 
            debounceTimer 
        = setTimeout(() => func.apply(context, args), delay) 
  } 
}

const error_message = (message) => Vue.toasted.error(message,{duration: 5000});
const success_message = (message) => Vue.toasted.success(message,{duration: 5000});
const replaceByDefault = (event) => (event.target.src = config.no_image);
const multipart_headers = () => ({'Content-Type': 'multipart/form-data'});

const set_axios_defaults = (token) => {
  window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  window.axios.defaults.headers.common["Accept"] = "application/json";
  window.axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
  window.axios.interceptors.response.use(
    res => res,
    debounce(err => {
      if (err.response.status === 401) {
        if(window.axios.defaults.headers.common.Authorization !== 'Bearer null'){
          Vue.toasted.error('Session Expired. Try login again',{
            duration: 5000
          });
        }
      }
      else if (err.response.status === 500) {
        Vue.toasted.error('Server error',{
          duration: 5000
        });
        // throw new Error(`${err.config.url} not found`);
      }
      else if (err.response.status === 422) {
        var message = Object.values(err.response.data.errors)[0][0]
        Vue.toasted.error(message,{
          duration: 5000
        });
        //throw new Error(`${err.config.url} not found`);
      }
      throw err;
    },500)
  );
}
const date_ranges = () =>{
  let today = new Date()
  today.setHours(0, 0, 0, 0)
      
  return {
    'Today': [moment().startOf('day').toDate(), moment().startOf('day').toDate()],
    'Yesterday': [moment().subtract(1,'day').startOf('day').toDate(), moment().subtract(1,'day').startOf('day').toDate()],
    'Last 7 days': [moment().subtract(1,'week').startOf('day').toDate(), moment().startOf('day').toDate()],
    'Last 30 Days': [moment().subtract(30,'days').startOf('day').toDate(),moment().startOf('day').toDate()],
    'This year': [new Date(today.getFullYear(), 0, 1), new Date(today.getFullYear(), 11, 31)],
    'Last month': [new Date(today.getFullYear(), today.getMonth() - 1, 1), new Date(today.getFullYear(), today.getMonth(), 0)],
  }
}

export { 
  authMethods,
  layoutMethods,
  authFackMethods,
  notificationMethods,
  debounce,
  error_message,
  success_message,
  replaceByDefault,
  multipart_headers,
  set_axios_defaults,
  date_ranges
}